import React from "react";
import { getData } from "app/data";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const HardwareSolution = () => {
  const hardwareSolutionData = getData("navModal")["47"];
  return (
    <section className="hardwareSolution">
      <div className="header">
        <p className="accent">
          <FormattedMessage id={"hardware_sec_header_desc"} />
        </p>
        <h2>
          <Link to="/hardware-solution">
            <FormattedMessage id={"hardware_solution"} />
          </Link>
        </h2>
        <p className="accent">
          <FormattedMessage id={"hardware_sec_header_desc2"} />
        </p>
      </div>
      <div className="contents">
        <div className="container row mx-auto">
          {hardwareSolutionData
            ? hardwareSolutionData.map(content => (
                <div className="col-lg-4 col-sm-12 p-3" key={content.renderId}>
                  <div className="card">
                    {content.imgUrl ? (
                      <Link className="img-wrapper" to={content.link}>
                        <img src={content.imgUrl} alt="solution" />
                      </Link>
                    ) : null}
                    <div className="pwrapper">
                      <h5 className="accent">{content.title}</h5>
                      <p>{content.description}</p>
                      <p>{content.description2}</p>
                    </div>
                    <Link
                      to={content.link}
                      className={`accent-button text-center`}
                    >
                      <FormattedMessage id={"explore"} />
                    </Link>
                  </div>
                </div>
              ))
            : null}
        </div>
      </div>
    </section>
  );
};

export default HardwareSolution;
